
window.addEventListener("load", ()=>{
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  // let viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  unhideElement(viewportWidth);
}) 

window.addEventListener("resize", ()=>{
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  // let viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  unhideElement(viewportWidth);
}) 

function unhideElement(width) {
  const shopNowMobile = document.getElementsByClassName('hide-elem');
  if (width < 768) {
     for (let i = 0; i < shopNowMobile.length; i++) {
       shopNowMobile[i].classList.add("unhide-elem");
     }
  }
}